import { render, staticRenderFns } from "./tableDataNotRegistered.vue?vue&type=template&id=15aa288b"
import script from "./tableDataNotRegistered.vue?vue&type=script&lang=js"
export * from "./tableDataNotRegistered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15aa288b')) {
      api.createRecord('15aa288b', component.options)
    } else {
      api.reload('15aa288b', component.options)
    }
    module.hot.accept("./tableDataNotRegistered.vue?vue&type=template&id=15aa288b", function () {
      api.rerender('15aa288b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/tableDataNotRegistered.vue"
export default component.exports